import { z } from 'zod';

import { schemaId } from '../../utils/schema.utils';

export const schemaSystemVariableCommon = z.object({
    id: schemaId,
});
